import { render, staticRenderFns } from "./AddChipManufacturer.vue?vue&type=template&id=3ceba0a1&"
import script from "./AddChipManufacturer.vue?vue&type=script&lang=ts&"
export * from "./AddChipManufacturer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports